module.exports = __webpack_public_path__ + "static/media/ic_launcher.384cf107.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_launcher.png
// module id = 347
// module chunks = 0